<template>
<div>
<v-overlay v-if="notifications.length > 0 && alertBox && !this.alertCookieValue">
<div class="main-alert">
      <div class="notification-item" v-for="(notification, index) in notifications" :key="index">
            <div v-if="notification.levels[0].id === 2" v-bind:class="notice">{{ notification.text}}</div>
             <div v-else-if="notification.levels[0].id === 1" v-bind:class="danger">{{ notification.text}}</div>
             <div v-else v-bind:class="warning">{{ notification.text}}</div>
      </div>
      <v-btn @click="dismissAlert">Zapri</v-btn>
      
    </div>

    <div class="text-center">
    </div>
    </v-overlay>
  </div>
</template>

<style lang="scss" scoped>
    @import 'alert-box.scss';
</style>

<script>
export default {
    data() {
        return {
        warning: 'warning',
        notice: 'notice',
        danger: 'danger',
        alertBox: true,
        overlay: true,
        alertCookieValue: null
        };
    },
    methods: {
      dismissAlert() {
        this.$cookies.set("CookieAlert", 1, "1d")
        this.alertCookieValue = 1;
      },
    },
	computed: {
		notifications() {
			return this.$store.getters.allNotifications
        },
	},
	mounted() {
    this.$store.dispatch("getNotifications")
    this.alertCookieValue = this.$cookies.get("CookieAlert")
	},
};
</script>